import graphql from "babel-plugin-relay/macro";

export const allContractsDropdown = graphql`
    fragment ContractFragments_AllContractsDropdown on LegalContract @relay(plural: true) {
        id,
        name
    }`